// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"styles":"f1b725b5fd7361afdecf","custom":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
};